import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, catchError, first } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { VssOrganizationTable} from '../shared/models/vss-organization-table.model';
import { VssOrganization } from '../shared/models/vss-organization.model';
import { SportCategory } from '../shared/models/sportCategory.model';
import { SharedService } from '../shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class VssOrganizationsService {


  public vssOrganizationTypeSubject: Subject<number> = new Subject();

  constructor(private _http: HttpClient, private _sharedService: SharedService) { }

  /**
   * getOrganizations
   */

  public getVssOrganizations(sportCats?: SportCategory[]) {
    return this._http.get<[VssOrganizationTable]>(environment.serverUrl + 'vss/organization/getByAccount').pipe(
      map(responseData => {
        // console.log(environment.serverUrl + 'vss/organization/getByAccount');
        // console.log('responseData', responseData);
        const organizationsArray: VssOrganizationTable[] = [];
        for (const key in responseData) {
          if (responseData.hasOwnProperty(key)) {
            const element = { ...responseData[key] };
            if (element.children) {
              element.children.forEach(child => {
                if (child.sportCategories) {
                  child.sportCategories.map((sc, i) => {
                    child.sportCategories[i] = this._sharedService.deepSearchSportCategoriesById(sc, sportCats);
                  });
                }
              });
            }
            organizationsArray.push(element);
          }
        }
        return organizationsArray;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public getVssOrganization(orgId: string): Observable<VssOrganization> {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId);
    // VssOrganization
    return this._http.get<VssOrganization>(environment.serverUrl + 'vss/organization/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        console.log(responseData);
        localStorage.setItem('orgId', responseData.organizationTypeId.toString());
        this.vssOrganizationTypeSubject.next(responseData.organizationTypeId);
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public getSportCategories(): Observable<SportCategory[]> {
    return this._http.get<SportCategory[]>(environment.serverUrl + 'sportCategories/get').pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public updateVssOrganization(organization: VssOrganization): Observable<any> {
    return this._http.post<{ id: number }>(environment.serverUrl + 'vss/organization/update', { organization }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public deleteImage(orgId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId.toString());
    return this._http.delete<void>(
      environment.serverUrl + 'vss/organization/deleteFile', { params: paramas, }
    ).pipe(
      map(() => {
        return true;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public submitOrganizationImage(file: File, fileName: string, orgId: number) {
    const formData = new FormData();
    formData.append('id', orgId.toString());
    formData.append('image', file, file.name);
    return this._http.post<any>(
      environment.serverUrl + 'vss/organization/upload',
      formData
    ).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
